import './Sidebar.less';
import React, {useState, useEffect} from 'react';
import ImageView from "../../../components/image-view/ImageView";
import __ from "../../../i18n";
import Icon from "../../../../bootstrap/components/icon/Icon";
import LessonPreviewer from "../lesson-previewer/LessonPreviewer";
import Popup from "../../../../bootstrap/components/popup/Popup";
import FreeEnrollButton from "../free-enroll-button/FreeEnrollButton";
import {PaidEnrollButton} from '../paid-enroll-button/PaidEnrollButton';
import {STATUS_ACTIVE, STATUS_INACTIVE} from '../../../model-constants/enrollment/statuses';
import {LearnNowButton} from '../learn-now-button/LearnNowButton';
import {CompleteEnrollmentButton} from '../complete-enrollment-button/CompleteEnrollmentButton';
import routes from '../../../routing/routes';
import VideoIcon from '../../../widgets/video-icon/VideoIcon';
import AudioIcon from '../../../widgets/autio-icon/AudioIcon';
import DocumentIcon from '../../../widgets/document-icon/DocumentIcon';
import QuizIcon from '../../../widgets/quiz-icon/QuizIcon';
import Countdown from '../countdown/Countdown';


export default function Sidebar({course, promotion, avatarImage, lessons, videos, enrollment}) {

    const [previewerShown, setPreviewerShown] = useState(false);

    const previewLessons = lessons.filter(t => t.is_preview === 1 && t.video_id !== null);

    const videoCount = lessons.filter(t => t.video_id !== null).length;
    const audioCount = lessons.filter(t => t.audio_id !== null).length;
    const documentCount = lessons.filter(t => t.document_id !== null).length;
    const quizCount = lessons.filter(t => t.quiz_id !== null).length;

    let salePrice = course.price;
    if (promotion) {
        salePrice = Math.floor(course.price * (100 - promotion.discount_percentage) / 100);
    }

    return <div className="sidebar">
        <div className="avatar-block">
            <ImageView
                image={avatarImage}
                ratio={1.5}
            />
            {
                previewLessons.length > 0 &&
                <div
                    className="overlay"
                    onClick={() => setPreviewerShown(true)}
                >
                    <Icon name="play-circle"/>
                </div>
            }
        </div>
        <div className="main-block">
            <div className="price">
                {
                    promotion &&
                    course.price > 0 &&
                    <div className="with-promotion">
                        <span className="list-price">{__('::price(CURRENCY, code)', {price: course.price})}</span>
                        <span className="discount">
                            {__('-::percentage%', {percentage: promotion.discount_percentage})}
                        </span>
                    </div>
                }
                <div className="sale-price">{__('::price(CURRENCY, code)', {price: salePrice})}</div>
            </div>
            {
                enrollment === null || enrollment.status === STATUS_INACTIVE ? (
                    salePrice > 0
                        ? <PaidEnrollButton course={course}/>
                        : <FreeEnrollButton course={course}/>
                ) : (
                    enrollment.status === STATUS_ACTIVE
                        ? <LearnNowButton course={course}/>
                        : <CompleteEnrollmentButton course={course}/>
                )
            }
            {
                promotion &&
                course.price > 0 &&
                <div className="promotion">
                    <a
                        className="promotion-link"
                        href={routes.promotion.getUrl(promotion.slug)}
                        title={promotion.name}
                    >
                        {promotion.name}
                    </a>
                    <div className="time-period">{__('::startTime(DATE, dateTime) - ::endTime(DATE, dateTime)', {
                        startTime: promotion.start_time,
                        endTime: promotion.end_time,
                    })}</div>
                    <Countdown endTime={promotion.end_time} />
                </div>
            }
        </div>
        <div className="summary-block">
            <h4>{__('This course includes:')}</h4>
            <table>
                <tbody>
                {
                    videoCount > 0 &&
                    <tr>
                        <td><VideoIcon/></td>
                        <td>{__('::count(PLURAL, 1 1 video, ! :@ videos)', {count: videoCount})}</td>
                    </tr>
                }
                {
                    audioCount > 0 &&
                    <tr>
                        <td><AudioIcon/></td>
                        <td>{__('::count(PLURAL, 1 1 audio, ! :@ audios)', {count: audioCount})}</td>
                    </tr>
                }
                {
                    quizCount > 0 &&
                    <tr>
                        <td><QuizIcon/></td>
                        <td>{__('::count(PLURAL, 1 1 test, ! :@ tests)', {count: quizCount})}</td>
                    </tr>
                }
                {
                    documentCount > 0 &&
                    <tr>
                        <td><DocumentIcon/></td>
                        <td>{__('::count(PLURAL, 1 1 downloadable document, ! :@ downloadable documents)', {count: documentCount})}</td>
                    </tr>
                }
                <tr>
                    <td><Icon name="infinity"/></td>
                    <td>{__('Full lifetime access')}</td>
                </tr>
                <tr>
                    <td><Icon name="diploma"/></td>
                    <td>{__('Certificate of completion')}</td>
                </tr>
                </tbody>
            </table>
        </div>
        {
            previewerShown &&
            <Popup name="course-app">
                <LessonPreviewer
                    previewLessons={previewLessons}
                    videos={videos}
                    close={() => setPreviewerShown(false)}
                />
            </Popup>
        }
    </div>;
}
